import { useContext } from 'react';
import { SchedulerContext } from '../Contexts/SchedulerContext';
export default function useSchedulerContext() {
    const context = useContext(SchedulerContext);
    if (!context) {
        throw new Error('useSchedulerContext must be used within a SchedulerContextProvider');
    }
    return context;
}
